import { Loadable } from '../../util/Loadable';

export const getPromotedGame = (state)=> state.promotion.currentPromotion;
